<template>
    <div v-if="scope.row[config.prop]!=undefined">
        <el-switch v-model="scope.row[config.prop]"
                       active-color="#3fd788"
                       inactive-color="#bfbfbf"
                       :class="{'disable-switch':scope.row.disable_edit}"
                       @change="context.changeSwitch(scope.row,scope.row.id)">
            </el-switch>
    </div>
    <div v-else>
      无对应字段~
    </div>
</template>

<script>

export default {
    name: "TDefaultStatus",
    cName:'开关',
    defaultProp:'status',
    // functional: true,
    // Props 是可选的
    props: ["scope", "config","context"],
    data() {
        return {
        };
    }
};
</script>
